module.exports = __webpack_public_path__ + "static/media/05.d8fa0d15.jpg";